import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import StatusB from './StatusB';
import styled from './index.module.scss';
// import StatusC from './StatusC';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styled.pageProduct}>
            {/* {pageStatus === IPageStatus.statusA && <StatusA />} */}
            {/* {pageStatus === IPageStatus.statusB && <StatusB />} */}
            <StatusB />
        </div>
    );
}
